import { Component, OnDestroy, OnInit } from '@angular/core';
import { ReportService } from '../reports-service/report.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { CsvService } from 'src/app/service/csv-service/csv.service';

@Component({
  selector: 'app-outbounding',
  templateUrl: './outbounding.component.html',
  styleUrls: ['./outbounding.component.css']
})
export class OutboundingComponent implements OnInit , OnDestroy {
  search='';
  todayDate;
  outBoundList = [];
  timeZone;


  constructor(
    private csvService : CsvService,
    private reportService : ReportService,
    private sharedDataService : SharedDataService
  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.timeZone = user.timeZone;



        }
      });
  }


  getMessages(){
    const payload = {
      startDate : this.todayDate[0],
      endDate : this.todayDate[1],
    }
    this.reportService.getOutBoundMessages(payload).subscribe((data)=>{
        this.outBoundList = data.result;
    })
  }

  onDateChange(event) {
    this.todayDate = [
      event[0].format("YYYY-MM-DD HH:mm:ss"),
      event[1].endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    ];
    this.getMessages()
  }

  getOutBoundReport(){
    this.csvService.downloadOutBoundReport(this.outBoundList, this.todayDate, this.timeZone);
  }

  ngOnDestroy(){

  }
}
